module.exports = __webpack_public_path__ + "img/logo.6a150e0.svg";